import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchMeetupsdtlbannersec } from "../services/Meetupsdtlbannersec";
import { API_BASE } from "../api/apiConfig";

const Meetupsdtlbannersec = () => {
  const { city } = useParams();
  const [meetup, setMeetup] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchMeetupsdtlbannersec(decodeURIComponent(city));

      if (res?.status && res?.data?.length > 0) {
        setMeetup(res.data[0]); // first meetup of city
      }
      setLoading(false);
    };

    loadBanner();
  }, [city]);

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!meetup) return <p className="text-center py-10">No meetup found</p>;

  return (
     <section className="relative bg-slate-900">
  {/* Back Button */}
  <div className="absolute left-0 right-0 top-0 z-10 mx-auto px-4 pt-6">
    <div className="container mx-auto">
      <button className="justify-center whitespace-nowrap text-sm font-medium transition-colors border h-10 group flex items-center rounded-full border-white/20 bg-black/30 px-4 py-2 text-white backdrop-blur-sm hover:bg-black/40">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="mr-1 h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
        Back to All Meetups
      </button>
    </div>
  </div>

  {/* Header Image */}
  <div className="relative h-[40vh] min-h-[300px] w-full md:h-[50vh] lg:h-[60vh]">
    <img
      alt={meetup?.heading}
      className="absolute inset-0 h-full w-full object-cover"
      src={
        meetup?.banner_image
          ? `${API_BASE}${meetup.banner_image}`
          : `${API_BASE}default.jpg`
      }
      onError={(e) => {
        e.currentTarget.src = `${API_BASE}default.jpg`;
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/40" />
  </div>

  {/* Overlay Content */}
  <div className="container absolute bottom-0 left-0 right-0 mx-auto px-4 py-10 md:py-12 text-white">
    <div className="flex flex-wrap items-center gap-3">
      {/* Categories */}
      {meetup?.category &&
        JSON.parse(meetup.category).map((cat, index) => (
          <div
            key={index}
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors
              ${
                index === 0
                  ? "bg-primary text-white hover:bg-primary/90"
                  : "bg-white/20 backdrop-blur-sm hover:bg-white/30"
              }`}
          >
            {cat}
          </div>
        ))}

      {/* Attending */}
      <div className="flex items-center bg-black/30 rounded-full px-3 py-1 text-white/90">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          className="mr-1.5 h-4 w-4 text-primary"
        >
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
        <span className="text-sm font-medium">
          {meetup.spots}/{meetup.total_spots} attending
        </span>
      </div>
    </div>

    {/* Title */}
    <h1 className="mt-3 text-2xl font-bold leading-tight md:text-3xl lg:text-4xl drop-shadow-sm">
      {meetup.heading}
    </h1>

    {/* Date Time Location */}
    <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3">
      <div className="flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-primary"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path d="M8 2v4" />
          <path d="M16 2v4" />
          <rect width={18} height={18} x={3} y={4} rx={2} />
          <path d="M3 10h18" />
        </svg>
        <span>{meetup.date}</span>
      </div>

      <div className="flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-primary"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
        >
          <circle cx={12} cy={12} r={10} />
          <polyline points="12 6 12 12 16 14" />
        </svg>
        <span>{meetup.time}</span>
      </div>

      <div className="flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5 text-primary"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
          <circle cx={12} cy={10} r={3} />
        </svg>
        <span>{meetup.city}</span>
      </div>
    </div>
  </div>
</section>

    

 
  );
};

export default Meetupsdtlbannersec;
